import React, { useEffect, useMemo, useCallback } from 'react';
import RangeSlider from '../bronson/RangeSlider';
import Datepicker from '../bronson/Datepicker';
import Select from '../bronson/Select';
import Traductor from '../Traductor';

import {
    filterYearPurchase,
    filterMonthPurchase,
} from '../../constants/Filters';

const BuyDatesFilters = ({ filterTitle, filters, updateFilters, options }) => {
    const t = useMemo(() => new Traductor(), []);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, [filters]);

    const getMaxDateDatepickers = useCallback(() => {
        const date = new Date();
        const day = date.getDate();
        const monthIndex = date.getMonth() + 1;
        const year = date.getFullYear();
        return day + '/' + monthIndex + '/' + year;
    }, []);

    const datePickerFromId = useMemo(
        () => options.filterFrom + '_' + options.filterView,
        [options.filterFrom, options.filterView]
    );
    const datePickerFrom = useMemo(
        () => ({
            id: datePickerFromId,
            type: '',
            label: t.getTraduction('Desde'),
            isRequired: false,
            maxDate: options?.infinite ? '' : getMaxDateDatepickers(),
        }),
        [datePickerFromId, getMaxDateDatepickers, options?.infinite, t]
    );

    const datePickerToId = useMemo(
        () => options.filterTo + '_' + options.filterView,
        [options.filterTo, options.filterView]
    );
    const datePickerTo = useMemo(
        () => ({
            id: datePickerToId,
            type: '',
            label: t.getTraduction('Hasta'),
            isRequired: false,
            maxDate: options?.infinite ? '' : getMaxDateDatepickers(),
        }),
        [datePickerToId, getMaxDateDatepickers, options?.infinite, t]
    );

    const getDateToTimestamp = useCallback(value => {
        var myDate = value;
        myDate = myDate.split('/');
        var newDate = myDate[1] + '/' + myDate[0] + '/' + myDate[2];
        return new Date(newDate).getTime() / 1000;
    }, []);

    const onChangeDatepickerFrom = useCallback(
        value => {
            const newFilters = { ...filters, [options.filterFrom]: value };
            if (
                getDateToTimestamp(
                    document.getElementById(datePickerToId).value
                ) < getDateToTimestamp(value)
            ) {
                newFilters[options.filterTo] = '';
            }

            if (!filters[options.filterTo] && value) {
                newFilters[options.filterTo] = getMaxDateDatepickers();
            }
            updateFilters(newFilters);
        },
        [
            datePickerToId,
            filters,
            getDateToTimestamp,
            getMaxDateDatepickers,
            options.filterFrom,
            options.filterTo,
            updateFilters,
        ]
    );

    const onChangeDatepickerTo = useCallback(
        value => {
            const newFilters = { ...filters };
            if (
                getDateToTimestamp(
                    document.getElementById(datePickerFromId).value
                ) > getDateToTimestamp(value)
            ) {
                newFilters[options.filterFrom] = '';
                newFilters[options.filterTo] = value;
            } else {
                newFilters[options.filterFrom] = document.getElementById(
                    datePickerFromId
                ).value;
                newFilters[options.filterTo] = value;
            }
            updateFilters(newFilters);
        },
        [
            datePickerFromId,
            filters,
            getDateToTimestamp,
            options.filterFrom,
            options.filterTo,
            updateFilters,
        ]
    );

    const onChangeYearRange = useCallback(
        value => {
            updateFilters({ ...filters, [filterYearPurchase]: value });
        },
        [filters, updateFilters]
    );

    const onChangeSelect = useCallback(
        value => {
            updateFilters({ ...filters, [filterMonthPurchase]: value });
        },
        [filters, updateFilters]
    );

    const printYearRange = useCallback(() => {
        if (filters.BuyYearMax && filters.BuyYearMax.length > 0) {
            const yearRangeFilterOptions = {
                id: 'yearRangeFilterOptions',
                label: t.getTraduction('Ano'),
                step: 1,
                pips: filters.BuyYearMax[1],
                range: [filters.BuyYearMax[0], filters.BuyYearMax[1]],
                labelClass: '',
                type: ['small'],
                tooltips: false,
                customValues: true,
                isDate: true,
            };
            return (
                <div className="o-layout__item  u-1/1">
                    <RangeSlider
                        filterTitle={t.getTraduction('Power')}
                        filterCode={filterYearPurchase}
                        value={filters[filterYearPurchase]}
                        setValue={onChangeYearRange}
                        options={yearRangeFilterOptions}
                    ></RangeSlider>
                </div>
            );
        }
    }, [filters, onChangeYearRange, t]);

    const printMonthSelect = useCallback(() => {
        if (options.Months) {
            let listMonths = [];
            if (options.Months && options.Months.length > 0) {
                options.Months.map(element =>
                    listMonths.push({
                        value: element.Id,
                        text: element.NameMonth,
                    })
                );
            }

            const monthOfPurchaseOptions = {
                id: 'monthOfPurchase',
                type: 'text',
                name: 'monthOfPurchase',
                text: t.getTraduction('Mes'),
                values: listMonths,
                showLabel: true,
            };

            return (
                <div className="o-layout__item  u-1/1 u-mt-large">
                    <Select
                        value={`${filters[filterMonthPurchase]}`}
                        onChange={e => onChangeSelect(e)}
                        options={monthOfPurchaseOptions}
                    ></Select>
                </div>
            );
        } else {
            return null;
        }
    }, [filters, onChangeSelect, options.Months, t]);

    return (
        <>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text ">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content c-vehicle-filters__item-content--input"
                aria-hidden="true"
            >
                <div className="c-accordion__content rema-c-accordion__content--full-height c-accordion__content--max-width">
                    <div className="o-layout">
                        <div className="o-layout__item  u-1/1">
                            <Datepicker
                                value={filters[options.filterFrom]}
                                onChange={onChangeDatepickerFrom}
                                options={datePickerFrom}
                            />
                        </div>
                        <div className="o-layout__item  u-1/1">
                            <Datepicker
                                value={filters[options.filterTo]}
                                onChange={onChangeDatepickerTo}
                                options={datePickerTo}
                            />
                        </div>
                        {printYearRange()}
                        {printMonthSelect()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BuyDatesFilters;
